import cn from 'get-classnames';
import { useMemo } from 'react';

const useClassName = (...classNames) => {
    classNames = classNames.join(' ');
    classNames = cn.tw(classNames);

    return useMemo(() => classNames, [classNames]);
};

export default useClassName;
